// extracted by mini-css-extract-plugin
export default {"popupHead":"DeactivationModal_popupHead__xW0yb","popupPara":"DeactivationModal_popupPara__ueZvg","popupButtonDiv":"DeactivationModal_popupButtonDiv__FsupO"};